"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationType = void 0;
exports.LocationType = {
    COMMERCIAL: 'COMMERCIAL',
    RESIDENTIAL: 'RESIDENTIAL',
    MARITIME_PORT: 'MARITIME_PORT',
    AIRPORT: 'AIRPORT',
    MILITARY_BASE: 'MILITARY_BASE'
};
//# sourceMappingURL=location-type.js.map